
<style scoped lang="scss">
.each-food-item {
    padding: 0.466667rem 0.333333rem 0 0.44rem;
    margin-top: 0.213333rem;
    background: $white;
    .title {
        margin-bottom: 0.373333rem;
        height: 0.533333rem;
        display: flex;
        align-items: center;
        .title-img {
            width: 0.613333rem;
            height: auto;
            margin-right: 0.16rem;
        }
        .title-text {
            font-size: 18px;
            font-weight: bold;
            color: $black;
        }
    }
    .each-type {
        border-top: 1px solid #ebebeb;
        padding: 0.453333rem 0;
        display: flex;

        .type-left-wra {
            width: 70%;
            .type-title {
                font-size: 16px;
                font-weight: bold;
                color: $black;
                margin-bottom: 0.24rem;
                line-height: 1.3;
                word-wrap: break-word;
            }
            .type-intro {
                color: $light-green;
                font-size: 12px;
                img {
                    width: 0.16rem;
                    margin-left: 0.16rem;
                    height: 0.266667rem;
                }
            }
        }
        .type-right-wra {
            width: 30%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-end;
            .price-btn {
                width: 1.84rem;
                height: 0.773333rem;
                color: $white;
                background: $blue;
                border-radius: 0.386667rem;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                .suffix {
                    font-size: 11px;
                    font-weight: bold;
                }
                .num {
                    vertical-align: bottom;
                    font-weight: bold;
                    font-size: 15px;
                }
            }
        }
    }
}
</style>

<template>
    <div class="each-food-item"
        v-if="foodData.length>0"
        v-cloak>
        <div class="title">
            <img :src="title.img"
                v-if="title.img"
                alt="ticket"
                class="title-img">
            <span class="title-text"
                v-text="title.text || ''"></span>
        </div>
        <div class="each-type"
            v-for="(item,index) of foodData"
            :key="index">
            <div class="type-left-wra">
                <div class="type-title"
                    v-text="item.name"></div>
                <div class="type-intro"
                    @click.stop="openVoucherModal(item)">使用说明<img src="https://oss.tuoxingwang.com/vaporetto-assets/scene/png/right-icon-green.png"
                        alt="right-icon"></div>
            </div>
            <div class="type-right-wra">
                <div class="price-btn"
                    @click.stop="toBuy(item.id)">
                    <span class="suffix">￥</span>
                    <span class="num"
                        v-text="item.salePrice"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FoodDetailItem",
    components: {},
    props: {
        foodData: {
            type: Array,
            default() {
                return [];
            }
        },
        title: Object
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        toBuy(foodId) {
            this.$router.push({
                name: "foodOrder",
                params: {
                    foodId
                }
            });
        },
        openVoucherModal(voucher) {
            this.$emit("openmodal", voucher);
        }
    }
};
</script>

